import styled, { AnyStyledComponent } from 'styled-components';
import { NavTypes } from './nav.types';

export const NavWrapper: AnyStyledComponent = styled.nav`
    padding: 20px 0;
`;

interface NavListWrapperProps {
    type: NavTypes
}

export const NavListWrapper: AnyStyledComponent = styled.ul`
    list-style-type: none;
    font-size: ${({type}: NavListWrapperProps) => type === NavTypes['MEDIUM'] ? '25px' : '35px'};
    margin: 0;
    padding: 0;

    li {
        margin-right: 20px;
        display: inline-block;
    }
    li:last-child {
        margin-right: 0;
    }
`;
